import request from '@/plugins/request';
let Api = {};
const sys = '/file/'
const pre = 'info';
// 列表
Api.tableList = function (data) {
    return request({
        url: `${sys}${pre}/getList`,
        method: 'get',
        params: data
    });
}
// 查看
Api.getTableById = function (id) {
    return request({
        url: `${sys}${pre}_id/${id}`,
        method: 'get'
    });
}
// 上传
Api.uploadUrl = `${sys}${pre}/upload`
// 批量上传
Api.batchUploadUrl = `${sys}${pre}/more-upload`
// 编辑
Api.editTable = function (data) {
    return request({
        url: `${sys}${pre}`,
        method: 'patch',
        data
    });
}
// 删除
Api.deleteTable = function (id) {
    return request({
        url: `${sys}${pre}/${id}`,
        method: 'delete'
    });
}
// 批量删除
Api.deleteTableAll = function (ids) {
    return request({
        url: `${sys}${pre}_ids/${ids}`,
        method: 'delete'
    });
}
// 下载
Api.download = function (fileId) {
    return request({
        url: `${sys}${pre}/batchDownLoad/${fileId}`,
        method: 'get'
    });
}
// 批量下载
Api.batchDownload = function (data) {
    return request({
        url: `${sys}${pre}/batchDownLoad`,
        method: 'post',
        data
    });
}

export default Api



// WEBPACK FOOTER //
// ./src/api/platform/file.js